import LayerSectionBase from './LayerSectionBase.js';

export default class ObjectSection extends LayerSectionBase {
  constructor(objectManager, previewWindowContainer, selection, requestDraw, mulLangTexts) {
    super(document.querySelector('#objectSection'), selection, requestDraw, {
      'New': {
        execute: () => this.add(this.getDisplayIdxSelected(), 1),
        check: () => this._getDisplaySzSelected() <= 1,
      },
      'Duplicate': {
        execute: () => this.duplicate(...this._getDisplayIdxSzSelected()),
        check: () => this._getDisplaySzSelected() >= 1,
      },
      'Delete': {
        execute: () => this.delete(...this._getDisplayIdxSzSelected()),
        check: () => this._getDisplaySzSelected() >= 1,
      },
      'Preview': {
        execute: () => previewWindowContainer.addWindow(this.getDisplayIdxSelected()),
        check: () => this._getDisplaySzSelected() === 1,
      },
    });
    this._objectManager = objectManager;
    this._mulLangTexts = mulLangTexts;
    this._selection = selection;
  }
  _selectInnerData(idx) {
    this._objectManager.select(idx);
  }
  _drawThumbnail(canvas, idx) {
    const imageDataManager = this._objectManager.getImageDataManager(idx);
    imageDataManager.drawFrameThumbnail(canvas, 0);
  }
  _doMove(srcIdx, srcSz, dstIdx) {
    // オブジェクトについてはchangeTrackerを通す必要はない
    this.move(srcIdx, srcSz, dstIdx);
  }
  add(idx, sz, show = true) {
    this._selection.finishIfNot();
    this._addDisplays(idx, sz, show);
    this._objectManager.add(idx, sz);
    this.select(idx);
  }
  duplicate(idx, sz) {
    this._selection.finishIfNot();
    this._addDisplays(idx, sz);
    this._objectManager.duplicate(idx, sz);
    this._updateThumbnails(idx, sz);
    this.select(idx, sz);
  }
  delete(idx, sz) {
    if(window.confirm(this._mulLangTexts.get('CONFIRM_DELETE_OBJECT'))) {
      this._selection.finishIfNot();
      this._deleteDisplays(idx, sz);
      this._objectManager.delete(idx, sz);

      const length = this._objectManager.getObjectsLength();
      if(length === 0) {
        this.add(0, 1);
      } else if(length === 1) {
        this.select(0);
      } else {
        this.select(Math.max(idx - 1, 0));
      }
    }
  }
  move(srcIdx, srcSz, dstIdx) {
    this._selection.finishIfNot();
    this._objectManager.move(srcIdx, srcSz, dstIdx);
    this._moveDisplays(srcIdx, srcSz, dstIdx);
    this.select(this.getDisplayIdxSelected());
  }
}
